import { Routes } from '@/utils/navigation/routes'

/**
 * ПРАВИЛА ДОВОДКИ ОПЛАТЫ, ПОДТВЕРЖДЁННОЙ НА СЕРВЕРЕ (utils/spec/confirmedPurchases.ts). Здесь только решения —
 * без хранилища, сети и событий, чтобы их можно было проверить под Node.
 */

export type ConfirmedPayment = { key: string; run_id: number | null; product_id: string; paid_at: string | null }

/**
 * Спрашивать ли сервер на этой загрузке. Только браузер, где кабинет или прогон уже есть: первый заход на лендинг
 * сервер не трогает. И не там, где покупку пишет кто-то другой или кабинета нет по смыслу: /thank-you пишет
 * её сама, консоль — экран оператора, страница «поделиться» — чужой поиск, и увод с неё в кабинет был бы похищением
 * экрана у того, кому ссылку прислали.
 */
export const confirmedSyncApplies = (input: { pathname: string; hasWorkspace: boolean; wizardRun: number | null }): boolean => {
  if (!input.hasWorkspace && input.wizardRun == null) return false
  const path = input.pathname
  if (path.startsWith(Routes.thankYou) || path.startsWith(Routes.console)) return false
  if (path.startsWith(Routes.share.replace('/:token', '/'))) return false
  return true
}

/**
 * Какие подтверждённые оплаты записать в этот браузер:
 *   — ключа ещё нет среди записанных (возврат с оплаты, ссылка возврата, прошлая доводка): одна покупка — одна
 *     запись и одни события, задвоенный Purchase портит оптимизацию рекламы;
 *   — товар узнаётся каталогом: неизвестный товар не назовёт ни пакет, ни сумму;
 *   — прогон есть в этом браузере (запись поиска или визард) или его нет вовсе (покупка до первого поиска).
 *     Прогон, которого здесь нет, записать не к чему: токена у браузера нет, и лист показался бы чужим.
 */
export const purchasesToRecord = (input: {
  confirmed: readonly ConfirmedPayment[]
  recorded: readonly string[]
  runsHere: ReadonlySet<number>
  known: (productId: string) => boolean
}): ConfirmedPayment[] => {
  const taken = new Set(input.recorded.map(String))
  const out: ConfirmedPayment[] = []
  for (const payment of input.confirmed) {
    if (taken.has(payment.key)) continue
    if (!input.known(payment.product_id)) continue
    if (payment.run_id != null && !input.runsHere.has(payment.run_id)) continue
    taken.add(payment.key)
    out.push(payment)
  }
  return out
}
